import { Alert } from "react-bootstrap";
import { isInternal } from "../../../helpers";

export const NoTemplate = () => {
  const text = isInternal() ? "this agent has" : "you have";
  return (
    <Alert variant="warning">{`It doesn't look like ${text} a template on file.`}</Alert>
  );
};
